import {
	type FieldValues,
	FormProvider,
	type UseFormReturn,
} from 'react-hook-form'

type FormProps<T extends FieldValues> = {
	children: React.ReactNode
} & UseFormReturn<T>

export function Form<T extends FieldValues>({
	children,
	...methods
}: FormProps<T>) {
	return <FormProvider {...methods}>{children}</FormProvider>
}
